import type { PropsWithChildren } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import styles from './GrupoDesplegable.module.css'

export function GrupoDesplegable({
  id,
  etiqueta,
  abierto,
  activo = false,
  onAlternar,
  children,
}: PropsWithChildren<{
  id: string
  etiqueta: string
  abierto: boolean
  activo?: boolean
  onAlternar: () => void
}>) {
  return (
    <section className={styles.disclosure} data-active={activo}>
      <button
        type="button"
        className={styles.disclosureButton}
        aria-expanded={abierto}
        aria-controls={id}
        onClick={onAlternar}
      >
        <span>{etiqueta}</span>
        {abierto ? <ChevronUp size={14} aria-hidden /> : <ChevronDown size={14} aria-hidden />}
      </button>
      {abierto ? <div id={id} className={styles.disclosureBody}>{children}</div> : null}
    </section>
  )
}
